/* =================== CARROSSEL PRUDUTOS =================== */
$(function () {
  $(".carrosel-produtos").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  if ($(".bloco-produto-fotoss").length > 0) {
    $(".bloco-produto-fotoss > ul").each(function () {
      //const swipe = $(this).hasClass("swipe");
      //const arrows = !$(this).hasClass("noarrows");
      var swipe = true;
      $(this)
        .slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          swipe: swipe,
          infinite: true,
          responsive: [
            {
              breakpoint: 760,
            },
          ],
        })
        .on("mousedown touchstart", function () {
          var $carroselPai = $(this).closest(".carrosel-anuncios");

          if ($carroselPai.length > 0) {
            $carroselPai[0].slick.setOption({
              swipe: false,
              autoplay: false,
            });
            $carroselPai[0].slick.slickPause();
          }
        })
        .on("afterChange", function (event, slick) {
          var $carroselPai = $(this).closest(".carrosel-anuncios");

          if ($carroselPai.length > 0) {
            $carroselPai[0].slick.setOption({
              swipe: true,
              autoplay: true,
              autoplaySpeed: 5000,
            });
            $carroselPai[0].slick.slickPlay();
          }
        });
    });
  }
});

/* =================== CARROSSEL PRODUTOS FOTO =================== */
